"use client"

import Image from "next/image"
import { ExternalLink, Menu, UtensilsCrossed } from "lucide-react"

import { useIsMobile } from "@/hooks/use-is-mobile"
import { Button } from "@/components/ui/button"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import { Icons } from "@/components/icons"

export function MobileSideMenu() {
  const isMobile = useIsMobile()

  if (!isMobile) return null

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <Menu className="size-6" />
        </Button>
      </SheetTrigger>

      <SheetContent side="left" className="w-full max-w-[320px] p-0">
        <SheetHeader className="sr-only">
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col h-full">
          {/* Main Content */}
          <div className="flex flex-col p-6 pb-4 space-y-6 flex-1">
            {/* Primary Actions */}
            <div className="space-y-3 mt-8">
              <Button
                variant="be"
                className="w-full h-11 text-base font-semibold rounded-xl"
              >
                Đăng ký
              </Button>
              <Button
                variant="outline"
                className="w-full h-12 text-base font-semibold rounded-xl border-2 border-gray-200 hover:bg-gray-50"
              >
                Đăng nhập
              </Button>
            </div>

            {/* Menu Items */}
            <div className="space-y-1">
              <button className="w-full text-left py-4 px-2 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-lg transition-colors">
                Tạo tài khoản doanh nghiệp
              </button>
              <button className="w-full text-left py-4 px-2 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-lg transition-colors">
                Thêm nhà hàng của bạn
              </button>
              <button className="w-full text-left py-4 px-2 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-lg transition-colors">
                Đăng ký để giao hàng
              </button>
              <button className="flex items-center justify-between w-full text-left py-4 px-2 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-lg transition-colors">
                <span>Đặt xe</span>
                <ExternalLink className="size-4" />
              </button>
            </div>
          </div>

          {/* Bottom Promotional Section */}
          <div className="p-6 pt-0">
            <div className="bg-gray-100 rounded-2xl p-4 flex items-start space-x-4">
              <Image
                src="/appicon.jpg"
                alt="app icon"
                width={48}
                height={48}
                className="rounded-lg"
              />
              <div className="flex-1">
                <p className="text-base font-semibold text-gray-900 leading-tight">
                  Tải app be để nhận được nhiều ưu đãi hơn.
                </p>
              </div>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
